module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "p-message"
    }
  }, [(_vm.visible) ? _c('div', {
    class: _vm.containerClass,
    attrs: {
      "role": "alert"
    }
  }, [_c('div', {
    staticClass: "p-message-wrapper"
  }, [_c('span', {
    class: _vm.iconClass
  }), _vm._v(" "), _c('div', {
    staticClass: "p-message-text"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.closable) ? _c('button', {
    directives: [{
      name: "ripple",
      rawName: "v-ripple"
    }],
    staticClass: "p-message-close p-link",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_c('i', {
    staticClass: "p-message-close-icon pi pi-times"
  })]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c46a3a46"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/message/Message.vue
// module id = 2399
// module chunks = 0